import { useEffect } from "react";
import {
  SITE_ADDRESS,
  SITE_CONTACT_EMAIL,
  SITE_DESCRIPTION,
  SITE_FOUNDED,
  SITE_LOCALE,
  SITE_LOGO,
  SITE_NAME,
  SITE_OG_IMAGE,
  SITE_SERVICES,
  SITE_SOCIAL,
  SITE_URL,
} from "@/config/seo";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: SITE_NAME,
  url: SITE_URL,
  logo: {
    "@type": "ImageObject",
    url: SITE_LOGO,
  },
  image: SITE_OG_IMAGE,
  description: SITE_DESCRIPTION,
  email: SITE_CONTACT_EMAIL,
  foundingDate: SITE_FOUNDED,
  address: {
    "@type": "PostalAddress",
    addressLocality: SITE_ADDRESS.addressLocality,
    addressRegion: SITE_ADDRESS.addressRegion,
    addressCountry: SITE_ADDRESS.addressCountry,
  },
  sameAs: [SITE_SOCIAL.linkedin, SITE_SOCIAL.instagram],
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: SITE_URL,
  name: SITE_NAME,
  description: SITE_DESCRIPTION,
  inLanguage: SITE_LOCALE,
  publisher: {
    "@id": `${SITE_URL}/#organization`,
  },
};

const professionalServiceSchema = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": `${SITE_URL}/#service`,
  name: SITE_NAME,
  url: SITE_URL,
  image: SITE_OG_IMAGE,
  description: SITE_DESCRIPTION,
  email: SITE_CONTACT_EMAIL,
  foundingDate: SITE_FOUNDED,
  areaServed: {
    "@type": "Country",
    name: "India",
  },
  address: {
    "@type": "PostalAddress",
    addressLocality: SITE_ADDRESS.addressLocality,
    addressRegion: SITE_ADDRESS.addressRegion,
    addressCountry: SITE_ADDRESS.addressCountry,
  },
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Marketing & Growth Services",
    itemListElement: SITE_SERVICES.map((service) => ({
      "@type": "Offer",
      itemOffered: {
        "@type": "Service",
        name: service,
      },
    })),
  },
  parentOrganization: {
    "@id": `${SITE_URL}/#organization`,
  },
};

const structuredData = [organizationSchema, websiteSchema, professionalServiceSchema];

export const Seo = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data";
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return null;
};
